// extracted by mini-css-extract-plugin
export var section = "collaboration-module--section--RdJi4";
export var buttonColumn = "collaboration-module--buttonColumn--yywuW";